import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ModelLocatorService } from "../config/model-locator.service";

/**
 * Connection, token, refresh-token
 * @author Starley Cazorla
 */

@Injectable({ providedIn: 'root' })
export class HttpService {

    private host: string = '';

    constructor(private http: HttpClient,
        private modelLocator: ModelLocatorService) {

        this.host = this.modelLocator.configUso.urlApiPadrao
    }

    /**
     * Sets header config
     * @author Starley Cazorla
     * @param [authToken]
     * @param [headers]
     * @returns header config with x-token
     */
    public setHeaderConfig(authToken?: boolean, headers?: any): any {
        let config = {
            headers: {
                "x-token": this.modelLocator.configUso.X_TOKEN_API
            }
        };

        if (authToken) {
            config.headers["auth-token"] = this.modelLocator.dadosLogin.hash_auth;
        }

        if (headers) {
            config.headers = headers;
        }

        return config.headers;
    }

    get(endpoint: string, params: any = {}, headers: any = {}): Observable<any> {
        return this.http.get(this.host + endpoint, {
            params: params,
            headers: new HttpHeaders(headers)
        });
    }

    post(endpoint: string, body: any = {}, headers: any = {}): Observable<any> {
        return this.http.post(this.host + endpoint, body, {
            headers: new HttpHeaders(headers)
        });
    }

    put(endpoint: string, body: any = {}, headers: any = {}): Observable<any> {
        return this.http.put(this.host + endpoint, body, {
            headers: new HttpHeaders(headers)
        });
    }

    delete(endpoint: string, params: any = {}, headers: any = {}): Observable<any> {
        return this.http.delete(this.host + endpoint, {
            params: params,
            headers: new HttpHeaders(headers)
        });
    }

    /**
     * Gets external
     * @author Starley Cazorla
     * @param endpoint
     * @param [params]
     * @param [headers]
     * @returns external
     */
    getExternal(endpoint: string, params: any = {}, headers: any = {}): Observable<any> {
        return this.http.get(endpoint, {
            params: params,
            headers: new HttpHeaders(headers)
        });
    }

    /**
     * Puts external
     * @author Starley Cazorla
     * @param endpoint
     * @param [body]
     * @param [headers]
     * @returns external
     */
    putExternal(endpoint: string, body: any = {}, headers: any = {}): Observable<any> {
        return this.http.put(endpoint, body, {
            headers: new HttpHeaders(headers)
        });
    }

}
